import React from "react";
import moment from "moment-timezone";
import $ from "jquery";
import { format } from "react-string-format";
import RShieldConfigurationsModal from "./RShieldConfigurationsModal";
import DLReadersHistoryModal from "./DLReadersHistoryModal";
import { AppContext } from "../../../../AppContext";

const DocumentHistoryPopup = ({
  modalForDocumentHistory,
  selectedLanguage,
  handlermodalForDocumentHistory,
  fileName,
  lstDocumentsHistoryDetails,
  dateFormatValueUpper,
  handleVersionHisrtyPageLevel,
  handleTermOfservicePopup,
  isDatetimeControl,
  applyTimeZoneToDisplay,
  timeZoneRef,
  timeZoneAbbrevation,
  handleVersionHistoryCanPrint,
}) => {
  const [rShieldModalOpen, setRShieldModalOpen] = React.useState(false);
  const [rShieldModalConfig, setRShieldModalConfig] = React.useState(null);
  const [dlReadersModalConfig, setDlReadersModalConfig] = React.useState({
    isOpen: false,
    dlEmail: "",
    dlName: "",
    readers: [],
    prevReaders: [],
    modifiedRecipientsList: [],
    modalMode: "modified",
  });

  const isDLRecord = (r) => {
    if (!r) return false;
    const val = r?.isDLGroup ?? r?.IsDLGroup ?? false;
    if (val === true || val === "true" || val === "True") return true;
    const ln = (r?.lastName || r?.LastName || "").trim();
    const fn = (r?.firstName || r?.FirstName || "").trim();
    return ln === "(DL)" || ln === "(Distribution List)" || fn === "(Distribution List)" || fn.includes("(Dl)") || fn.includes("(DL)");
  };

  const getDLEmailRef = (r) => {
    if (!r) return "";
    return (r?.dlemail || r?.DLEmail || r?.dlEmail || "").trim().toLowerCase();
  };

  const isDLHeaderRecord = (r) => {
    if (!isDLRecord(r)) return false;
    const dlRef = getDLEmailRef(r);
    const selfEmail = (r?.email || r?.Email || "").trim().toLowerCase();
    return !dlRef || dlRef === selfEmail;
  };

  const getDLReferenceForEmail = (email, allRecipients = []) => {
    const target = (email || "").trim().toLowerCase();
    if (!target) return "";
    const member = allRecipients.find((r) => {
      const rEmail = (r?.email || r?.Email || "").trim().toLowerCase();
      return rEmail === target;
    });
    return getDLEmailRef(member);
  };

  const isMemberOfAnyDLInVersion = (email, allRecipients = []) => {
    const target = (email || "").trim().toLowerCase();
    if (!target) return false;
    return allRecipients.some((r) => {
      const rEmail = (r?.email || r?.Email || "").trim().toLowerCase();
      const dlRef = getDLEmailRef(r);
      return rEmail === target && Boolean(dlRef) && dlRef !== target;
    });
  };

  const formatDLLinkText = (dl) => {
    const email = (dl.email || dl.Email || "").trim();
    let fn = (dl.firstName || dl.FirstName || "").trim();
    let ln = (dl.lastName || dl.LastName || "").trim();

    if (ln === "(DL)" || ln === "(Distribution List)") {
      ln = "";
    }
    if (fn === "(DL)" || fn === "(Distribution List)") {
      fn = "";
    }

    let groupName = fn && ln ? (fn + " " + ln) : (fn || ln);
    groupName = groupName.replace(/\s*\((DL|dl|Distribution List)\)\s*$/i, "").trim();

    if (groupName) {
      return groupName + " <" + email + "> (DL)";
    }
    return "<" + email + "> (DL)";
  };

  const handleOpenDLReadersModal = (dlEmail, dlName, currentVersion, previousVersion, mode = "modified") => {
    const allRecipients = currentVersion?.documentOptions?.recipients || [];
    const prevRecipients = previousVersion?.documentOptions?.recipients || [];
    const modifiedList = currentVersion?.lstDocumentRecipientDto || [];
    const targetEmail = (dlEmail || "").trim().toLowerCase();

    // Show ONLY members who accessed (have code)
    const dlMembers = allRecipients.filter((r) => {
      const dlemail = getDLEmailRef(r);
      const rEmail = (r?.email || r?.Email || "").trim().toLowerCase();
      if (dlemail !== targetEmail || rEmail === targetEmail) return false;
      const hasCode = Boolean((r?.code || r?.Code || "").toString().trim());
      return hasCode;
    });

    const prevDLMembers = prevRecipients.filter((r) => {
      const dlemail = getDLEmailRef(r);
      const rEmail = (r?.email || r?.Email || "").trim().toLowerCase();
      if (dlemail !== targetEmail || rEmail === targetEmail) return false;
      const hasCode = Boolean((r?.code || r?.Code || "").toString().trim());
      return hasCode;
    });

    setDlReadersModalConfig({
      isOpen: true,
      dlEmail,
      dlName,
      readers: dlMembers,
      prevReaders: prevDLMembers,
      modifiedRecipientsList: modifiedList,
      modalMode: mode,
    });
  };
  if (!modalForDocumentHistory) return null;
  function rowclickHistory(event) {
    $(event.target).closest("tr").next(".fold").toggleClass("open");
    $(event.target).closest("tr").toggleClass("open");
  }

  function openRShieldHistoryModal(clickedItem) {
    const clickedIndex = lstDocumentsHistoryDetails.findIndex(
      (h) => h.id === clickedItem.id
    );
    if (clickedIndex === -1) return;
    const current = lstDocumentsHistoryDetails[clickedIndex];
    const previous = lstDocumentsHistoryDetails[clickedIndex + 1] || null;

    const currentOptions = current.documentOptions?.rShieldOptions || {};
    const previousOptions = previous?.documentOptions?.rShieldOptions || {};
    const changed = previous
      ? {
        focusProtection:
          !!currentOptions.focusProtection !==
          !!previousOptions.focusProtection,
        resumeOnFullScreen:
          !!currentOptions.resumeOnFullScreen !==
          !!previousOptions.resumeOnFullScreen,
        focusLossLimit:
          !!currentOptions.focusLossLimit !== !!previousOptions.focusLossLimit ||
          (!!currentOptions.focusLossLimit &&
            currentOptions.focusLossLimitValue !==
            previousOptions.focusLossLimitValue),
        notifySender:
          !!currentOptions.notifySender !== !!previousOptions.notifySender,
        banReader: !!currentOptions.banReader !== !!previousOptions.banReader,
        whenLimitReached:
          !!currentOptions.focusLossLimit &&
          currentOptions.whenLimitReached !== previousOptions.whenLimitReached,
      }
      : {
        focusProtection: false,
        resumeOnFullScreen: false,
        focusLossLimit: false,
        notifySender: false,
        banReader: false,
        whenLimitReached: false,
      };
    const config = {
      id: current.id,
      updatedOn: current.modified != null ? current.modified : current.created,
      rShieldEnabled: current.documentOptions?.rShield,
      options: currentOptions,
      changed,
    };

    setRShieldModalConfig(config);
    setRShieldModalOpen(true);
  }
  function displayAuthType(authType) {
    if (authType.toLowerCase() === "email") {
      return selectedLanguage.LstLanguageCodes.UI_Email;
    } else if (authType.toLowerCase() === "text") {
      return selectedLanguage.LstLanguageCodes.UI_Text;
    } else if (authType.toLowerCase() === "both") {
      return (
        selectedLanguage.LstLanguageCodes.UI_Email +
        ", " +
        selectedLanguage.LstLanguageCodes.UI_Text
      );
    }
    return "";
  }

  return (
    <div className="modalCus documentversion-history" id="myModal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="card-body pt-1 pb-0">
            <div
              className="mb-2 mt-3 justify-content-between d-flex"
              style={{ borderBottom: "2px solid #918d8d4d" }}>
              <h4 htmlFor="">
                <p className="fw-bold">
                  {
                    selectedLanguage.LstLanguageCodes
                      .UI_DocumentversionHistory
                  }
                </p>
              </h4>
              <button
                type="button"
                className="btn btn-outline-danger modalclose download"
                onClick={(e) => handlermodalForDocumentHistory()}>
                <span className="material-icons font-20">
                  highlight_off
                </span>
              </button>
            </div>
            <div className="row">
              <div className="input-group field mt-1 res-nowwrap ">
                <p
                  className="fw-bold text-word-break"
                  style={{
                    fontSize: "17px",
                    marginBottom: "0px !important",
                  }}>
                  {selectedLanguage.LstLanguageCodes.UI_DocumentName}:{" "}
                  {fileName}
                </p>
              </div>
            </div>
          </div>

          <div
            className="card-body pt-0"
            style={{
              maxHeight: "350px",
              overflow: "auto",
              overflowX: "hidden",
              display: "block",
              paddingRight: "3px",
              marginRight: "10px",
            }}>
            <div className="table-responsive res-card">
              <table
                className="fold-table table tablelayout "
                cellPadding="0"
                cellSpacing="0">
                <thead className="bg-lightblue">
                  <tr className="">
                    <th className="" style={{ width: "19%" }}>
                      {selectedLanguage.LstLanguageCodes.UI_versionNo}
                    </th>
                    <th className="" style={{ width: "33%" }}>
                      {selectedLanguage.LstLanguageCodes.UI_UpdatedTime + " " + "(" + timeZoneAbbrevation.current + ")"}
                    </th>
                    <th className="">
                      {selectedLanguage.LstLanguageCodes.UI_UpdatedBy}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {/* <!-------- First one ---------> */}

                  {lstDocumentsHistoryDetails.length > 0 &&
                    lstDocumentsHistoryDetails.map((item, i) => (
                      <tr className="borderrow">
                        <td colSpan={8} className="innertTableTd">
                          <table
                            className="popupDocumentHistory"
                            cellPadding="0"
                            cellSpacing="0">
                            <tr
                              className="view"
                              onClick={rowclickHistory}
                              id={"trMain" + i}>
                              <td
                                className="text-start"
                                style={{
                                  width: "19%",
                                  borderleft: "0.1rem solid #e7e5e570",
                                }}>
                                <div className="d-flex flex-wrap textwrap">
                                  {"V" +
                                    (lstDocumentsHistoryDetails.length - i)}
                                </div>
                              </td>
                              <td
                                className="text-start"
                                style={{
                                  width: "33%",
                                  borderLeft: "0.1rem solid #e7e5e570",
                                }}>
                                <div className="d-flex flex-wrap textwrap">
                                  {item.modified != null
                                    ? (moment.utc(
                                      applyTimeZoneToDisplay(
                                        new Date(item.modified),
                                        timeZoneRef.current
                                      ))
                                    ).format(dateFormatValueUpper + " HH:mm")
                                    : moment.utc(
                                      applyTimeZoneToDisplay(
                                        new Date(item.created),
                                        timeZoneRef.current
                                      )
                                    ).format(dateFormatValueUpper + " HH:mm")}
                                </div>
                              </td>
                              <td className="text-start" style={{ borderLeft: "0.1rem solid #e7e5e570" }}>
                                <div
                                  className="d-flex flex-wrap "
                                  title={item.modifiedBy}>
                                  <p className="textwrap mb-0">
                                    {" "}
                                    {item.modifiedBy}
                                  </p>
                                </div>
                              </td>
                            </tr>
                            <tr className="fold" id={"trChailed" + i}>
                              <td colSpan="8">
                                <div className="">
                                  <div
                                    className=""
                                    style={{ width: "100%" }}>
                                    <table className="table table-borderless tableHistorydetails">
                                      <tbody>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_AccessControl
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              {item.securityLevel === 3 ? (
                                                <span
                                                  style={{
                                                    marginLeft: "-5px",
                                                  }}
                                                  className={
                                                    item.isSecuritylevelChanged ==
                                                      true
                                                      ? "highlight"
                                                      : ""
                                                  }>
                                                  {" "}
                                                  {
                                                    selectedLanguage
                                                      .LstLanguageCodes
                                                      .UI_LimitReaders
                                                  }
                                                </span>
                                              ) : item.securityLevel ===
                                                2 ? (
                                                <span
                                                  style={{
                                                    marginLeft: "-2px",
                                                  }}
                                                  className={
                                                    item.isSecuritylevelChanged ==
                                                      true
                                                      ? "highlight"
                                                      : ""
                                                  }>
                                                  {
                                                    selectedLanguage
                                                      .LstLanguageCodes
                                                      .UI_TrackReaders
                                                  }
                                                </span>
                                              ) : (
                                                <span
                                                  style={{
                                                    marginLeft: "-5px",
                                                  }}
                                                  className={
                                                    item.isSecuritylevelChanged ==
                                                      true
                                                      ? "highlight"
                                                      : ""
                                                  }>
                                                  {" "}
                                                  {
                                                    selectedLanguage
                                                      .LstLanguageCodes
                                                      .UI_TrackViews
                                                  }
                                                </span>
                                              )}
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_Status
                                              }
                                              :{" "}
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isDocumentEnabled ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .enabled === true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Active
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Expired}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        {AppContext.ShowRPDLite && (
                                          <>
                                            <tr>
                                              <td className="ColHistory">
                                                <span>{selectedLanguage.LstLanguageCodes.UI_Pages}:{" "}</span>
                                              </td>
                                              <td className="ColHistory">
                                                <div className="d-flex flex-wrap textwrap">
                                                  <span className={item.isPagesChanged === true ? "highlight" : ""}>
                                                    {item.pages}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="ColHistory">
                                                <span>{selectedLanguage.LstLanguageCodes.UI_OriginalFileSize}:{" "}</span>
                                              </td>
                                              <td className="ColHistory">
                                                <div className="d-flex flex-wrap textwrap">
                                                  {item.inputFiles && item.inputFiles.length > 0 && (
                                                    <span className={item.isInputFilesChanged === true ? "highlight" : ""}>
                                                      {(() => {
                                                        let totalKB = 0;
                                                        let validFound = false;
                                                        item.inputFiles.forEach(file => {
                                                          const sizeStr = file.fileSize?.toString().trim().toLowerCase();
                                                          if (!sizeStr) return;
                                                          const sizeValue = parseFloat(sizeStr);
                                                          if (isNaN(sizeValue)) return;
                                                          validFound = true;
                                                          if (sizeStr.includes("mb"))
                                                            totalKB += sizeValue * 1024;
                                                          else if (sizeStr.includes("kb"))
                                                            totalKB += sizeValue;
                                                          else
                                                            totalKB += sizeValue;
                                                        });
                                                        if (!validFound) return "";
                                                        // Round the value to nearest whole number
                                                        if (totalKB >= 1024)
                                                          return `${Math.round(totalKB / 1024)} MB`;
                                                        else
                                                          return `${Math.round(totalKB)} KB`;
                                                      })()}
                                                    </span>
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </>)
                                        }
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_Launches
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              {isDatetimeControl === "false" ? (
                                                <span
                                                  className={
                                                    item.isStartTimeValueChanged === true ? "highlight" : ""
                                                  }
                                                >
                                                  {item.documentOptions.startTime == null ||
                                                    item.documentOptions.startTime === ""
                                                    ? ""
                                                    : moment.utc(
                                                      applyTimeZoneToDisplay(new Date(item.documentOptions.startTime),
                                                        timeZoneRef.current
                                                      )
                                                    ).format(dateFormatValueUpper) +
                                                    " " +
                                                    "(" + timeZoneAbbrevation.current + ")"}
                                                </span>
                                              ) : (
                                                <span
                                                  className={
                                                    item.isStartTimeValueChanged === true ? "highlight" : ""
                                                  }
                                                >
                                                  {item.documentOptions.startTime == null ||
                                                    item.documentOptions.startTime === ""
                                                    ? ""
                                                    : moment.utc(
                                                      applyTimeZoneToDisplay(
                                                        new Date(item.documentOptions.startTime),
                                                        timeZoneRef.current
                                                      )
                                                    ).format(dateFormatValueUpper + " HH:mm") +
                                                    " " +
                                                    "(" + timeZoneAbbrevation.current + ")"}
                                                </span>
                                              )}
                                            </div>
                                          </td>

                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_Expires
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              {isDatetimeControl === "false" ? (
                                                <span
                                                  className={
                                                    item.isExpiryTimeValueChanged === true ? "highlight" : ""
                                                  }
                                                >
                                                  {item.documentOptions.expiryTime == null ||
                                                    item.documentOptions.expiryTime === ""
                                                    ? ""
                                                    : moment.utc(
                                                      applyTimeZoneToDisplay(
                                                        new Date(item.documentOptions.expiryTime),
                                                        timeZoneRef.current
                                                      )
                                                    ).format(dateFormatValueUpper) +
                                                    " " +
                                                    "(" + timeZoneAbbrevation.current + ")"}
                                                </span>
                                              ) : (
                                                <span
                                                  className={
                                                    item.isExpiryTimeValueChanged === true ? "highlight" : ""
                                                  }
                                                >
                                                  {item.documentOptions.expiryTime == null ||
                                                    item.documentOptions.expiryTime === ""
                                                    ? ""
                                                    : moment.utc(
                                                      applyTimeZoneToDisplay(
                                                        new Date(item.documentOptions.expiryTime),
                                                        timeZoneRef.current
                                                      )
                                                    ).format(dateFormatValueUpper + " HH:mm") +
                                                    " " +
                                                    "(" + timeZoneAbbrevation.current + ")"}
                                                </span>
                                              )}
                                            </div>
                                          </td>

                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_RestrictToDomains
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isDomainsValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {
                                                  item.documentOptions
                                                    .domains
                                                }
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_AllowedIP
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            {item.documentOptions.ips
                                              .length > 0 &&
                                              item.documentOptions.ips.map(
                                                (ips, j) => (
                                                  <div className="d-flex flex-wrap ">
                                                    <span
                                                      className={
                                                        item.isIpsValueChanged ==
                                                          true
                                                          ? "highlight"
                                                          : ""
                                                      }>
                                                      {ips}{" "}
                                                    </span>
                                                  </div>
                                                )
                                              )}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_MaxReadsperReader
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isMaxReadsValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .maxReads === 0
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Unlimited
                                                  : item.documentOptions
                                                    .maxReads}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_MaxviewsPerDocument
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isMaxViewsPerDocumentValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .maxViewsPerDocument === 0
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Unlimited
                                                  : item.documentOptions
                                                    .maxViewsPerDocument}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_AllowResponsesTo
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isAllowResponsesToValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {
                                                  item.documentOptions
                                                    .allowResponsesTo
                                                }
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_SendVerificationCode
                                              }
                                              :
                                            </span>
                                          </td>
                                          {item.securityLevel !== 1 && (
                                            <td className="ColHistory">
                                              <div className="d-flex flex-wrap textwrap">
                                                <span
                                                  className={
                                                    (item.isSMSChanged ==
                                                      true || item.isEmailChanged == true || (item.isSMSChanged == true && item.isEmailChanged == true))
                                                      ? "highlight"
                                                      : ""
                                                  }>
                                                  {(item.documentOptions
                                                    .isSMS && item.documentOptions.isEmail)
                                                    ? `${selectedLanguage.LstLanguageCodes.UI_Email}, ${selectedLanguage.LstLanguageCodes.UI_Text}`
                                                    : item.documentOptions.isSMS
                                                      ? `${selectedLanguage.LstLanguageCodes.UI_Text}`
                                                      : item.documentOptions.isEmail
                                                        ? `${selectedLanguage.LstLanguageCodes.UI_Email}`
                                                        : ``
                                                  }
                                                </span>
                                              </div>
                                            </td>
                                          )}
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_Watermark
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isWaterValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .watermark === 1
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Confidential
                                                  : item.documentOptions
                                                    .watermark === 2
                                                    ? selectedLanguage
                                                      .LstLanguageCodes
                                                      .UI_Draft
                                                    : item.documentOptions
                                                      .watermark === 3
                                                      ? selectedLanguage
                                                        .LstLanguageCodes
                                                        .UI_MyLogo
                                                      : selectedLanguage
                                                        .LstLanguageCodes
                                                        .UI_None}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_BannedRegions
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isBannedRegionValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.regions}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_TimeStamp
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isTimestampValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .timestamp == true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Enabled
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Disabled}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_CanPrint
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.iscanPrintValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .print == true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Enabled
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Disabled}
                                              </span>
                                              {item.documentOptions.print === true && (
                                                <a className={item.iscanPrintView === true && item.documentOptions.recipients.length > 0 ? "bgYellow pointer" : "pointer"}
                                                  style={{ padding: "0px 5px 1px 5px", }}
                                                  onClick={() => handleVersionHistoryCanPrint(item.id)}>
                                                  {selectedLanguage.LstLanguageCodes.UI_View}
                                                </a>
                                              )}
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_MaxPrintsPerReader
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isMaxPrintsPerReaderChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .maxPrintsPerReader === 0
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Unlimited
                                                  : item.documentOptions
                                                    .maxPrintsPerReader}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_MaxPrintsPerDocument
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isMaxPrintsPerDocumentChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .maxPrintsPerDocument === 0
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Unlimited
                                                  : item.documentOptions
                                                    .maxPrintsPerDocument}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_DisplayDistributionlist
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isDistributionListValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .distributionList == true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Enabled
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Disabled}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_Voting
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isVotingValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .voting == true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Enabled
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Disabled}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_ShareVotes
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isVoteSharingValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .voteSharing == true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Enabled
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Disabled}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_Pagelevelrestrictions
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isPageLevelRestrictionChanged ===
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .pageLevelRestriction ==
                                                  true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Enabled
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Disabled}
                                              </span>{" "}
                                              <span>
                                                {" "}
                                                {item.isPageLevelRestrictionVarForView ===
                                                  true && (
                                                    <a
                                                      className={
                                                        item.isPageLevelRestrictionViewHighligte
                                                          ? "bgYellow pointer"
                                                          : "pointer"
                                                      }
                                                      style={{
                                                        padding:
                                                          "0px 5px 1px 5px",
                                                      }}
                                                      onClick={() =>
                                                        handleVersionHisrtyPageLevel(
                                                          item.id
                                                        )
                                                      }>
                                                      {
                                                        selectedLanguage
                                                          .LstLanguageCodes
                                                          .UI_View
                                                      }
                                                    </a>
                                                  )}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_IDLeakers
                                              }
                                              :{" "}
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isSteganographyValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .steganography == true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Enabled
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Disabled}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_EDisclosure
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="">
                                              <span
                                                className={
                                                  item.isEDisclosureChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .eDisclosure == true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Enabled
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Disabled}
                                              </span>
                                              {" "}
                                              {item.documentOptions.eDisclosure ?
                                                <span>
                                                  <a className="pointer"
                                                    style={{
                                                      padding:
                                                        "0px 5px 1px 5px",
                                                    }}

                                                    onClick={() => handleTermOfservicePopup(item.eDisclosureTermsOfService
                                                    )}
                                                  >
                                                    {
                                                      selectedLanguage
                                                        .LstLanguageCodes
                                                        .UI_View
                                                    }
                                                  </a></span> : ""}
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_RShield
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isRShieldValueChanged ===
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .rShield == true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Enabled
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Disabled}
                                              </span>{" "}
                                              <span>
                                                {item.documentOptions.rShield === true && (
                                                  <a
                                                    className={
                                                      item.isRShieldOptionsChanged
                                                        ? "bgYellow pointer"
                                                        : "pointer"
                                                    }
                                                    style={{
                                                      padding:
                                                        "0px 5px 1px 5px",
                                                    }}
                                                    onClick={() =>
                                                      openRShieldHistoryModal(
                                                        item
                                                      )
                                                    }>
                                                    {
                                                      selectedLanguage
                                                        .LstLanguageCodes
                                                        .UI_View
                                                    }
                                                  </a>
                                                )}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span> {selectedLanguage?.LstLanguageCodes?.UI_IPChangeDetection} : </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span className={(item.isIPChangeDetectionValueChanged === true || item.isIPChangeDetectionOptionsChanged === true) ? "highlight" : ""}>
                                                {(() => {
                                                  const isEnabled = (item.documentOptions?.ipChangeDetection ?? item.documentOptions?.IPChangeDetection) === true;
                                                  if (!isEnabled) {
                                                    return selectedLanguage?.LstLanguageCodes?.UI_Disabled;
                                                  }
                                                  const enabledText = selectedLanguage?.LstLanguageCodes?.UI_Enabled;
                                                  const ipOpts = item.documentOptions?.ipChangeDetectionOptions || item.documentOptions?.IPChangeDetectionOptions || {};
                                                  const selectedLabels = [];
                                                  if (ipOpts.banReader || ipOpts.BanReader) {
                                                    selectedLabels.push(selectedLanguage?.LstLanguageCodes?.UI_BanReader);
                                                  }
                                                  if (ipOpts.reAuthenticateReader || ipOpts.ReAuthenticateReader) {
                                                    selectedLabels.push(selectedLanguage?.LstLanguageCodes?.UI_ReAuthenticateReader);
                                                  }
                                                  if (ipOpts.notifySender || ipOpts.NotifySender) {
                                                    selectedLabels.push(selectedLanguage?.LstLanguageCodes?.UI_NotifySender);
                                                  }
                                                  return selectedLabels.length > 0
                                                    ? `${enabledText} (${selectedLabels.join(", ")})` : enabledText;
                                                })()}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <>
                                          {i < lstDocumentsHistoryDetails.length - 1 &&
                                            (item.securityLevel === 3 || item.securityLevel === 2 || item.isRPDDL === true ||
                                              (item.isPageLevelRestrictionVarForView &&
                                                item.isDistributionsChanged)) ? (
                                            (() => {
                                              const prevVersion = lstDocumentsHistoryDetails[i + 1];
                                              const prevRecipients = prevVersion?.documentOptions?.recipients || [];
                                              const allRecipients = item.documentOptions?.recipients || [];
                                              const dlHeaders = allRecipients.filter(isDLHeaderRecord);

                                              const newDLs = dlHeaders.filter((dl) => {
                                                const dlEmail = (dl.email || dl.Email || "").trim().toLowerCase();
                                                const headerInDist = (item.distributionChangedEmails || []).some((d) => (d.email || d.Email || "").trim().toLowerCase() === dlEmail);
                                                const newMemberAccessed = allRecipients.some((r) => {
                                                  if (getDLEmailRef(r) !== dlEmail || (r.email || "").trim().toLowerCase() === dlEmail) return false;
                                                  const hasCode = Boolean((r?.code || "").toString().trim());
                                                  if (!hasCode) return false;
                                                  const prev = prevRecipients.find((p) => (p.email || "").trim().toLowerCase() === (r.email || "").trim().toLowerCase());
                                                  const prevHadCode = Boolean((prev?.code || "").toString().trim());
                                                  return !prev || !prevHadCode;
                                                });
                                                return headerInDist || newMemberAccessed;
                                              });

                                              const individualNewRecipients = (item.distributionChangedEmails || []).filter(
                                                (data) => !isDLHeaderRecord(data) && !isMemberOfAnyDLInVersion(data.email, allRecipients)
                                              );

                                              if (newDLs.length === 0 && individualNewRecipients.length === 0) {
                                                return null;
                                              }

                                              return (
                                                <tr>
                                                  <td className="ColHistory">
                                                    <span>
                                                      {selectedLanguage.LstLanguageCodes.UI_NewAutherizedReaders}:
                                                    </span>
                                                  </td>
                                                  <td className="ColHistory">
                                                    <div className="d-flex flex-wrap textwrap align-items-center">
                                                      {newDLs.map((dl, dlIdx) => (
                                                        <div className="d-flex flex-wrap me-2" key={"dl-new-" + dlIdx}>
                                                          <span
                                                            className={item.isDistributionsChanged == true ? "highlight" : ""}
                                                            style={{ color: "#0d6efd", textDecoration: "underline", cursor: "pointer", }}
                                                            onClick={() => handleOpenDLReadersModal(dl.email || dl.Email, dl.firstName || dl.FirstName || dl.name || "Distribution List", item, prevVersion, "new")}
                                                          >
                                                            {formatDLLinkText(dl)}
                                                          </span>
                                                        </div>
                                                      ))}
                                                      {individualNewRecipients.map((data, j) => (
                                                        <span key={"indiv-new-" + j} className={item.isDistributionsChanged == true ? "highlight me-2" : "me-2"}>
                                                          {data.firstName != "" && data.lastName == ""
                                                            ? data.firstName + "<" + data.email + ">" + displayAuthType(data?.authType ?? "") + " " + data.mobileCountryCode + " " + data.mobileNumber
                                                            : data.firstName == "" && data.lastName != ""
                                                              ? data.lastName + "<" + data.email + ">" + displayAuthType(data?.authType ?? "") + " " + data.mobileCountryCode + " " + data.mobileNumber
                                                              : data.firstName != "" && data.lastName != ""
                                                                ? data.firstName + " " + data.lastName + "<" + data.email + ">" + displayAuthType(data?.authType ?? "") + " " + data.mobileCountryCode + " " + data.mobileNumber
                                                                : data.email + " " + displayAuthType(data?.authType ?? "") + " " + data.mobileCountryCode + " " + data.mobileNumber}
                                                          {data.reference?.trim() !== "" ? " " + data.reference : ""}
                                                        </span>
                                                      ))}
                                                    </div>
                                                  </td>
                                                </tr>
                                              );
                                            })()
                                          ) : (
                                            ""
                                          )}
                                          {i < lstDocumentsHistoryDetails.length - 1 && (item.securityLevel === 3 || item.securityLevel === 2 || item.isRPDDL === true) ? ((() => {
                                            const allRecipients = item.documentOptions?.recipients || [];
                                            const modifiedList = item.lstDocumentRecipientDto || [];
                                            const prevVersion = lstDocumentsHistoryDetails[i + 1];
                                            const prevRecipients = prevVersion?.documentOptions?.recipients || [];
                                            const dlHeaders = allRecipients.filter(isDLHeaderRecord);

                                            const modifiedDLs = dlHeaders.filter((dl) => {
                                              const dlEmail = (dl.email || dl.Email || "").trim().toLowerCase();
                                              const headerModified = modifiedList.some((m) => (m.email || m.Email || "").trim().toLowerCase() === dlEmail);
                                              const memberInModified = modifiedList.some((m) => {
                                                const ref = getDLEmailRef(m) || getDLReferenceForEmail(m.email, allRecipients);
                                                if (ref !== dlEmail) return false;
                                                const recip = allRecipients.find((r) => (r.email || r.Email || "").trim().toLowerCase() === (m.email || m.Email || "").trim().toLowerCase());
                                                return Boolean((recip?.code || recip?.Code || m?.code || m?.Code || "").toString().trim());
                                              });
                                              const memberChanged = allRecipients.some((m) => {
                                                if (getDLEmailRef(m) !== dlEmail || (m.email || "").trim().toLowerCase() === dlEmail) return false;
                                                const hasCode = Boolean((m?.code || "").toString().trim());
                                                if (!hasCode) return false;
                                                const prev = prevRecipients.find((p) => (p.id && m.id && p.id === m.id) || ((p.email || "").trim().toLowerCase() === (m.email || "").trim().toLowerCase()));
                                                if (!prev) return false;
                                                const prevEnabled = prev.enabled ?? prev.Enabled ?? true;
                                                const currEnabled = m.enabled ?? m.Enabled ?? true;
                                                const prevStatus = prev.status || prev.Status || (prevEnabled ? "Active" : "Banned");
                                                const currStatus = m.status || m.Status || (currEnabled ? "Active" : "Banned");
                                                if (prevEnabled !== currEnabled || prevStatus !== currStatus) return true;
                                                if ((prev.firstName || "").trim() !== (m.firstName || "").trim()) return true;
                                                if ((prev.lastName || "").trim() !== (m.lastName || "").trim()) return true;
                                                if ((prev.mobileNumber || "").trim() !== (m.mobileNumber || "").trim()) return true;
                                                if ((prev.mobileCountryCode || "").trim() !== (m.mobileCountryCode || "").trim()) return true;
                                                if ((prev.reference || "").trim() !== (m.reference || "").trim()) return true;
                                                if ((prev.authType || "").trim() !== (m.authType || "").trim()) return true;
                                                return false;
                                              });
                                              return headerModified || memberInModified || memberChanged;
                                            });

                                            const individualRecipients = modifiedList.filter(
                                              (data) => !isDLHeaderRecord(data) && !isMemberOfAnyDLInVersion(data.email, allRecipients)
                                            );

                                            if (modifiedDLs.length === 0 && individualRecipients.length === 0) {
                                              return null;
                                            }

                                            return (
                                              <tr>
                                                <td className="ColHistory">
                                                  <span>
                                                    {selectedLanguage.LstLanguageCodes.UI_ModifiedReaders}:
                                                  </span>
                                                </td>
                                                <td className="ColHistory">
                                                  <div className="d-flex flex-wrap align-items-center">
                                                    {modifiedDLs.map((dl, dlIdx) => (
                                                      <div className="d-flex flex-wrap me-2" key={"dl-mod-" + dlIdx}>
                                                        <span
                                                          className={item.isDocumentRecipientEnabled == true ? "highlight" : ""}
                                                          style={{ color: "#0d6efd", textDecoration: "underline", cursor: "pointer", }}
                                                          onClick={() => handleOpenDLReadersModal(dl.email || dl.Email, dl.firstName || dl.FirstName || dl.name || "Distribution List", item, prevVersion, "modified")}
                                                        >
                                                          {formatDLLinkText(dl)}
                                                        </span>
                                                      </div>
                                                    ))}
                                                    {individualRecipients.length > 0 &&
                                                      individualRecipients.map((data, j) =>
                                                        data.enabled == true ? (
                                                          <div className="d-flex flex-wrap" key={"indiv-mod-" + j}>
                                                            <span className={item.isDocumentRecipientEnabled == true ? "highlight me-2" : "me-2"}>
                                                              {data.firstName != "" && data.lastName == ""
                                                                ? data.firstName + "<" + data.email + ">" + displayAuthType(data?.authType ?? "") + (data.isMobileNumOrCountryCodeModified && data.mobileCountryCode && data.mobileNumber ? " " + data.mobileCountryCode + " " + data.mobileNumber : "") + (data.isFirstorLastModified != true && !data.isMobileNumOrCountryCodeModified && data.isReferenceModified != true ? " (" + selectedLanguage.LstLanguageCodes.UI_Active + ")" : "")
                                                                : data.firstName == "" && data.lastName != ""
                                                                  ? data.lastName + "<" + data.email + ">" + displayAuthType(data?.authType ?? "") + (data.isMobileNumOrCountryCodeModified && data.mobileCountryCode && data.mobileNumber ? " " + data.mobileCountryCode + " " + data.mobileNumber : "") + (data.isFirstorLastModified != true && !data.isMobileNumOrCountryCodeModified && data.isReferenceModified != true ? " (" + selectedLanguage.LstLanguageCodes.UI_Active + ")" : "")
                                                                  : data.firstName != "" && data.lastName != ""
                                                                    ? data.firstName + " " + data.lastName + "<" + data.email + ">" + displayAuthType(data?.authType ?? "") + (data.isMobileNumOrCountryCodeModified && data.mobileCountryCode && data.mobileNumber ? " " + data.mobileCountryCode + " " + data.mobileNumber : "") + (data.isFirstorLastModified != true && !data.isMobileNumOrCountryCodeModified && data.isReferenceModified != true ? " (" + selectedLanguage.LstLanguageCodes.UI_Active + ")" : "")
                                                                    : data.email + " " + displayAuthType(data?.authType ?? "") + (data.isMobileNumOrCountryCodeModified && data.mobileCountryCode && data.mobileNumber ? " " + data.mobileCountryCode + " " + data.mobileNumber : "") + (data.isFirstorLastModified != true && !data.isMobileNumOrCountryCodeModified && data.isReferenceModified != true && (!data.isAuthTypeChanged) ? " (" + selectedLanguage.LstLanguageCodes.UI_Active + ")" : "")} {data.reference?.trim() !== "" ? " " + data.reference : ""}
                                                            </span>
                                                          </div>
                                                        ) : (
                                                          <div className="d-flex flex-wrap" key={"indiv-mod-" + j}>
                                                            <span className={item.isDocumentRecipientEnabled == true ? "highlight me-2" : "me-2"}>
                                                              {data.firstName != "" && data.lastName == ""
                                                                ? data.firstName + "<" + data.email + ">" + displayAuthType(data?.authType ?? "") + (data.isMobileNumOrCountryCodeModified && data.mobileCountryCode && data.mobileNumber ? " " + data.mobileCountryCode + " " + data.mobileNumber : "") + (data.isFirstorLastModified != true && !data.isMobileNumOrCountryCodeModified && data.isReferenceModified != true ? " (" + (data.status == "Pause" ? selectedLanguage.LstLanguageCodes.UI_Pause.trim() : selectedLanguage.LstLanguageCodes.UI_Banned) + ")" : "")
                                                                : data.firstName == "" && data.lastName != ""
                                                                  ? data.lastName + "<" + data.email + ">" + displayAuthType(data?.authType ?? "") + (data.isMobileNumOrCountryCodeModified && data.mobileCountryCode && data.mobileNumber ? " " + data.mobileCountryCode + " " + data.mobileNumber : "") + (data.isFirstorLastModified != true && !data.isMobileNumOrCountryCodeModified && data.isReferenceModified != true ? " (" + (data.status == "Pause" ? selectedLanguage.LstLanguageCodes.UI_Pause.trim() : selectedLanguage.LstLanguageCodes.UI_Banned) + ")" : "")
                                                                  : data.firstName != "" && data.lastName != ""
                                                                    ? data.firstName + " " + data.lastName + "<" + data.email + ">" + displayAuthType(data?.authType ?? "") + (data.isMobileNumOrCountryCodeModified && data.mobileCountryCode && data.mobileNumber ? " " + data.mobileCountryCode + " " + data.mobileNumber : "") + (data.isFirstorLastModified != true && !data.isMobileNumOrCountryCodeModified && data.isReferenceModified != true ? " (" + (data.status == "Pause" ? selectedLanguage.LstLanguageCodes.UI_Pause.trim() : selectedLanguage.LstLanguageCodes.UI_Banned) + ")" : "")
                                                                    : data.email + " " + displayAuthType(data?.authType ?? "") + (data.isMobileNumOrCountryCodeModified && data.mobileCountryCode && data.mobileNumber ? " " + data.mobileCountryCode + " " + data.mobileNumber : "") + (data.isFirstorLastModified != true && !data.isMobileNumOrCountryCodeModified && data.isReferenceModified != true && !data.isAuthTypeChanged ? " (" + (data.status == "Pause" ? selectedLanguage.LstLanguageCodes.UI_Pause.trim() : selectedLanguage.LstLanguageCodes.UI_Banned) + ")" : "")}
                                                              {data.reference?.trim() !== "" ? " " + data.reference : ""}
                                                            </span>
                                                          </div>
                                                        )
                                                      )}
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                          })()
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="row mt-3 d-flex align-items-center justify-content-between">
              <p className="w-auto">
                {format(
                  selectedLanguage.LstLanguageCodes.UI_Showing1to12,
                  1,
                  lstDocumentsHistoryDetails.length,
                  lstDocumentsHistoryDetails.length
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
      <RShieldConfigurationsModal
        isOpen={rShieldModalOpen}
        onClose={() => setRShieldModalOpen(false)}
        selectedLanguage={selectedLanguage}
        rShieldConfig={rShieldModalConfig}
        dateFormatValueUpper={dateFormatValueUpper}
        applyTimeZoneToDisplay={applyTimeZoneToDisplay}
        timeZoneRef={timeZoneRef}
      />
      <DLReadersHistoryModal
        isOpen={dlReadersModalConfig.isOpen}
        onClose={() => setDlReadersModalConfig((prev) => ({ ...prev, isOpen: false }))}
        dlEmail={dlReadersModalConfig.dlEmail}
        dlName={dlReadersModalConfig.dlName}
        readers={dlReadersModalConfig.readers}
        prevReaders={dlReadersModalConfig.prevReaders}
        modifiedRecipientsList={dlReadersModalConfig.modifiedRecipientsList}
        modalMode={dlReadersModalConfig.modalMode}
        selectedLanguage={selectedLanguage}
      />
    </div>
  );
};
export default DocumentHistoryPopup;
